import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import StethoscopeIcon from '../assets/images/stethoscope.svg';

function ItemsList(props) {
  const { itemsList, limit = 3, path = [], itemStyleClass, separator, morePrefix, moreStyleClass } = props;
  const [toolTipText, setToolTipText] = useState('View More');

  useEffect(() => {
    if (itemsList && itemsList.length > limit) {
      let tooltipText = '';
      itemsList.forEach((item, index) => {
        if (index >= limit) {
          tooltipText += getValue(item) + (index < itemsList.length - 1 ? ' | ' : '');
        }
      });
      setToolTipText(tooltipText);
    }
  }, [itemsList]);

  const getValue = (item) => {
    let value = item;
    path.forEach((pItem) => {
      value = value[pItem];
    });
    return value;
  };

  return (
    <>
      {itemsList &&
        itemsList.map((item, index) => {
          if (index < limit) {
            return (
              <span className={itemStyleClass} key={item.id}>
                <img src={StethoscopeIcon} alt='' style={{ marginRight: 8, display: 'inline-block' }} />
                {getValue(item)} {separator && (itemsList.length > 4 || index < itemsList.length - 1) ? separator : ''}
              </span>
            );
          }
        })}
      {itemsList && itemsList.length > limit && (
        <Tooltip title={toolTipText} trigger={['click', 'hover']} placement={'bottom'}>
          <span className={moreStyleClass ? moreStyleClass : itemStyleClass} onClick={() => {}} className='moreItems'>
            {itemsList.length - limit + (morePrefix ? morePrefix : '') + ' more'}
          </span>
        </Tooltip>
      )}
    </>
  );
}

export default ItemsList;
